import { useEvent, useState } from 'hooks'
import { saveAs } from 'file-saver'
import axios from 'axios'
import { ContainerComponent, Loader } from 'component'
import { getFileDownloaderComponents } from './selector'
import { fileDownloader } from './constant'

type State = {
	buttons: NodeListOf<HTMLElement> | null
}

export const FileDownloader = (() => {
	const { state, setState } = useState<State>()

	const initClick = () => {
		const { buttons } = state

		if (buttons === null) {
			return
		}

		const click = useEvent<MouseEvent>(document, 'click')
		click.register((entry) => {
			const { target } = entry.e

			if (!(target instanceof HTMLElement)) {
				return
			}

			const button = target.closest(fileDownloader.selector.button)

			if (!button) {
				return
			}

			entry.e.preventDefault()

			let targetUrl = button.getAttribute(fileDownloader.attribute.url)

			if (button instanceof HTMLAnchorElement) {
				targetUrl = button.href
			}

			if (targetUrl === null) {
				return
			}

			Loader.create(ContainerComponent.getContainer('loader'), { absolute: true })

			axios
				.get(targetUrl)
				.then((response) => {
					const disposition = response.headers['content-disposition']

					if (!disposition) {
						return
					}

					const matches = fileDownloader.regex.filename.exec(disposition)
					if (matches === null || !matches[1]) {
						return
					}

					if (matches[1].startsWith('"')) {
						matches[1] = matches[1].substring(1)
					}

					if (matches[1].endsWith('"')) {
						matches[1] = matches[1].substring(0, matches[1].length - 1)
					}
					const fileName = decodeURI(matches[1])

					const blob = new Blob([response.data])

					saveAs(URL.createObjectURL(blob), fileName)
				})
				.finally(() => {
					Loader.destroy(ContainerComponent.getContainer('loader'))
				})
		})
	}

	const init = () => {
		setState({ ...getFileDownloaderComponents() })

		initClick()
	}

	return {
		init,
	}
})()
